// export const proccessErrorMessage = (error) => {
//   const userErrorMessage =
//     error?.response?.data?.message === "error" &&
//     error?.response?.data?.errors?.name
//       ? error?.response?.data?.errors?.name
//       : error?.response?.data?.message;
//   console.log(
//     typeof error?.response?.data?.errors[0],
//     typeof error?.response?.data?.errors === "object",
//     typeof error?.response?.data?.message,
//     typeof error?.response?.data?.message === "object"
//   );

//   return userErrorMessage;
// };

export const proccessErrorMessage = (error) => {
  const responseData = error?.response?.data;
  const responseDataError = responseData?.error;
  const responseDataErrors = responseData?.errors;
  const responseDataMessage = responseData?.message;

  let userErrorMessage;

  const innerErrors =
    (responseDataMessage === "The given data was invalid." ||
      responseDataMessage === "error") &&
    responseDataErrors &&
    typeof responseDataErrors === "object"
      ? responseDataErrors
      : typeof responseDataMessage === "object"
      ? responseDataMessage
      : responseDataErrors;

  const proccessedInnerErrors = [];
  if (innerErrors) {
    for (let x in innerErrors) {
      proccessedInnerErrors.push(innerErrors[x]);
    }
  }

  const actuallError =
    (responseDataMessage === "The given data was invalid." ||
      responseDataMessage === "error") &&
    responseDataErrors &&
    typeof responseDataErrors === "object" &&
    proccessedInnerErrors.length > 0
      ? proccessedInnerErrors?.join(" ")
      : responseDataMessage
      ? responseDataMessage
      : responseDataError
      ? responseDataError
      : responseDataErrors
      ? responseDataErrors
      : typeof responseDataMessage === "object"
      ? proccessedInnerErrors?.join(" ")
      : "";

  switch (actuallError) {
    case "timeout of 20000ms exceeded":
      userErrorMessage = "Request Timed Out";
      break;
    default:
      userErrorMessage =
        typeof actuallError === "string"
          ? actuallError.length > 0
            ? actuallError
            : "Please check your network connection."
          : "An error has occurred, please try again";
      break;
  }
  return userErrorMessage?.toLowerCase()?.includes("sql") ||
    userErrorMessage?.toLowerCase()?.includes("php")
    ? "An unexpected error has occurred"
    : userErrorMessage === "error"
    ? "An unknown error occurred, please try again"
    : userErrorMessage;
};
